import { LoaderFunctionArgs, RouteObject } from "react-router-dom"

import { DashboardGiftCardsIndex } from "~/src/components/DashboardGiftCards/DashboardGiftCardsIndex"
import { ErrorPage } from "~/src/components/ErrorPage"
import { appClient } from "~/src/lib/appClients"

export const basename = (storeId: string) => `/dashboard/stores/${storeId}/gift_cards`

const createRoutes = (): RouteObject[] => [
  {
    id: "dashboardGiftCardsIndexRoute",
    path: "/dashboard/stores/:store_id/gift_cards",
    element: <DashboardGiftCardsIndex />,
    hydrateFallbackElement: <></>,
    errorElement: <ErrorPage />,
    shouldRevalidate: () => false,
    loader: async ({ params }: LoaderFunctionArgs) => {
      const { store_id } = params
      const response = await appClient.get(`/dashboard/stores/${store_id}/gift_cards`, {
        headers: { Accept: "application/json" },
      })
      return response.data
    },
  },
]

export default createRoutes
